import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {AdminLayoutRoutes} from './admin-layout.routing';
import {DashboardComponent} from '../../dashboard/dashboard.component';
import {UserProfileComponent} from '../../user-profile/user-profile.component';
import {TableListComponent} from '../../table-list/table-list.component';
import {TypographyComponent} from '../../typography/typography.component';
import {IconsComponent} from '../../icons/icons.component';
import {GestionPartenaireComponent} from '../../user-profile/gestion-partenaire/gestion-partenaire.component';
import {GestionClientComponent} from '../../user-profile/gestion-client/gestion-client.component';
import {NjoyCommonModule} from '../../shared/modules/njoy-common/njoy-common.module';
import {DetailClientComponent} from '../../user-profile/gestion-client/detail-client/detail-client.component';
import {OffresComponent} from '../../offres/offres.component';
import {ChartModule} from 'primeng/chart';
import {CalendarModule} from 'primeng/calendar';
import {SelectButtonModule} from 'primeng/selectbutton';
import {DatePipe} from '@angular/common';


@NgModule({
    imports: [
        RouterModule.forChild(AdminLayoutRoutes),
        NjoyCommonModule,
        ChartModule,
        CalendarModule,
        SelectButtonModule,

    ],
    exports: [
        OffresComponent
    ],
    declarations: [
        DashboardComponent,
        UserProfileComponent,
        TableListComponent,
        TypographyComponent,
        IconsComponent,
        GestionPartenaireComponent,
        GestionClientComponent,
        DetailClientComponent, OffresComponent

    ],
    providers: [DatePipe]
})

export class AdminLayoutModule {
}
